(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aq-header-2026"]) return;
  try {
    
  if (!customElements.get('aq-header')) {
    customElements.define('aq-header', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.openButton = this.querySelector('[data-aq-menu-open]');
        this.closeButton = this.querySelector('[data-aq-menu-close]');
        this.details = Array.from(this.querySelectorAll('[data-aq-mega-details]'));
        this.openButton?.addEventListener('click', () => {
          this.dialog?.showModal();
          this.openButton.setAttribute('aria-expanded', 'true');
        });
        this.closeButton?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog?.addEventListener('close', () => {
          this.openButton?.setAttribute('aria-expanded', 'false');
          this.openButton?.focus();
        });
        this.details.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            this.details.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          });
          if (this.dataset.openOnHover === 'true') {
            const desktopHover = window.matchMedia('(min-width: 990px)');
            const megaMenu = item.querySelector('.aq-header__mega');
            let closeTimer;
            const keepOpen = () => {
              if (!desktopHover.matches) return;
              window.clearTimeout(closeTimer);
              item.setAttribute('open', '');
            };
            const closeAfterLeave = () => {
              if (!desktopHover.matches) return;
              window.clearTimeout(closeTimer);
              closeTimer = window.setTimeout(() => item.removeAttribute('open'), 220);
            };
            item.addEventListener('mouseenter', keepOpen);
            item.addEventListener('mouseleave', closeAfterLeave);
            megaMenu?.addEventListener('mouseenter', keepOpen);
            megaMenu?.addEventListener('mouseleave', closeAfterLeave);
          }
        });
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) {
            this.details.forEach((item) => item.removeAttribute('open'));
          }
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.details.forEach((item) => item.removeAttribute('open'));
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aq-layout-runtime"]) return;
  try {
    (()=>{const VERSION='2026-08-17.3';window.__AQ_LAYOUT_STABILITY_VERSION__=VERSION;const previewMode=(()=>{const params=new URLSearchParams(window.location.search);return params.has('preview_theme_id')||Boolean(window.Shopify?.designMode)||window.Shopify?.theme?.role==='unpublished'||document.documentElement.classList.contains('shopify-design-mode');})();const nodeLabel=(node)=>{if(!node||node.nodeType!==1)return 'unknown element';const id=node.id?`#${node.id}`:'';const classes=[...node.classList].slice(0,3).map((name)=>`.${name}`).join('');return `${node.tagName.toLowerCase()}${id}${classes}`.slice(0,120);};const startClsMeter=()=>{if(!previewMode||!('PerformanceObserver' in window))return;const meter=document.createElement('div');meter.id='aq-cls-meter';meter.dataset.status='good';meter.innerHTML='<strong>CLS 0.000 · GOOD</strong><span>Waiting for layout shifts…</span>';document.body.append(meter);let sessionValue=0;let sessionStart=0;let lastEntryTime=0;let maxValue=0;let largestTarget='none';const entries=[];const render=()=>{const status=maxValue<=0.1?'good':maxValue<=0.25?'okay':'poor';meter.dataset.status=status;meter.firstElementChild.textContent=`CLS ${maxValue.toFixed(3)}· ${status.toUpperCase()}`;meter.lastElementChild.textContent=`Largest target:${largestTarget}`;window.__aqClsAudit={version:VERSION,value:maxValue,target:largestTarget,entries:[...entries]};};try{const observer=new PerformanceObserver((list)=>{list.getEntries().forEach((entry)=>{if(entry.hadRecentInput)return;if(entry.startTime-lastEntryTime>1000||entry.startTime-sessionStart>5000){sessionValue=entry.value;sessionStart=entry.startTime;}else{sessionValue+=entry.value;}lastEntryTime=entry.startTime;const target=nodeLabel(entry.sources?.[0]?.node);entries.push({value:entry.value,sessionValue,target,time:entry.startTime});if(entries.length>30)entries.shift();if(sessionValue>=maxValue){maxValue=sessionValue;largestTarget=target;}render();});});observer.observe({type:'layout-shift',buffered:true});}catch(error){meter.lastElementChild.textContent='CLS observer is not supported in this browser.';}};const FEATURE_SELECTOR='.aq-feature h3,.aq-garment-callout strong';const ensureFeatureAccordion=(container)=>{if(!container||container.querySelector('[data-aq-generated-features]'))return;const details=document.createElement('details');details.setAttribute('data-aq-generated-features','');const summary=document.createElement('summary');summary.append(document.createTextNode('Features'));const plus=document.createElement('span');plus.setAttribute('aria-hidden','true');plus.textContent='+';summary.append(plus);const body=document.createElement('div');body.className='aq-rte';const list=document.createElement('ul');list.setAttribute('data-aq-generated-feature-list','');body.append(list);details.append(summary,body);container.prepend(details);};const hydrateFeatureLists=(product)=>{const titles=[...product.querySelectorAll(FEATURE_SELECTOR)].map((node)=>node.textContent.trim()).filter(Boolean).filter((title,index,all)=>all.indexOf(title)===index).slice(0,7);if(!titles.length)return;product.querySelectorAll('[data-aq-generated-feature-list]').forEach((list)=>{if(list.dataset.hydrated==='true')return;const fragment=document.createDocumentFragment();titles.forEach((title)=>{const item=document.createElement('li');item.textContent=title;fragment.append(item);});list.replaceChildren(fragment);list.dataset.hydrated='true';});};const classifyProductOptions=(product)=>{const optionsRoot=product.querySelector('[data-aq-product-options]');const namesNode=product.querySelector('[data-aq-option-names]');if(!optionsRoot||!namesNode||optionsRoot.dataset.aqReserveChecked==='true')return;try{const names=JSON.parse(namesNode.textContent||'[]');const hasOptions=names.length>0&&!(names.length===1&&names[0]==='Title');optionsRoot.classList.toggle('aq-no-options',!hasOptions);if(!hasOptions)optionsRoot.hidden=true;optionsRoot.dataset.aqReserveChecked='true';}catch(error){optionsRoot.dataset.aqReserveChecked='true';}};const normalizeAqProduct=(selector)=>{if(!selector)return;let variants=selector.variants;if(!Array.isArray(variants)){try{variants=JSON.parse(selector.querySelector('[data-aq-variants]')?.textContent||'[]');}catch(error){variants=[];}}if(!variants.length)return;const currentId=String(selector.dataset.currentVariantId||'');const current=variants.find((variant)=>String(variant.id)===currentId);const firstAvailable=variants.find((variant)=>variant.available);if((!current||!current.available)&&firstAvailable){if(typeof selector.applyProductSelection==='function'){selector.applyProductSelection(firstAvailable);}else{selector.dataset.currentVariantId=String(firstAvailable.id);const hidden=selector.querySelector('[data-aq-kaching-variant]');if(hidden)hidden.value=firstAvailable.id;}const button=selector.querySelector('[data-aq-add]');if(button){button.disabled=false;const text=button.querySelector('[data-aq-button-text]');if(text&&selector.dataset.purchaseMode==='kaching')text.textContent='Add to cart';}}selector.querySelectorAll('.aq-option-pill--colour').forEach((button)=>{const value=String(button.dataset.optionValue||'').toLowerCase();if(value.includes('key lime')||value.includes('keylime')){const swatch=button.querySelector('.aq-option-pill__swatch');if(swatch)swatch.style.background='#d2decc';}});};const patchAqSelector=()=>{const Selector=customElements.get('aq-bundle-selector');if(!Selector||Selector.prototype.__armateqStablePatched)return;Selector.prototype.__armateqStablePatched=true;const originalColourBackground=Selector.prototype.colourBackground;if(typeof originalColourBackground==='function'){Selector.prototype.colourBackground=function(value,assignedSwatch){const key=String(value||'').trim().toLowerCase();if(key.includes('key lime')||key.includes('keylime'))return '#d2decc';if(typeof assignedSwatch==='string'&&assignedSwatch)return assignedSwatch;return originalColourBackground.call(this,value,assignedSwatch);};}Selector.prototype.add=async function(){const selections=[...this.items.querySelectorAll('select')].map((select)=>select.value);const quantity=this.dataset.purchaseMode==='quantity'?Math.max(1,Number(this.quantityInput?.value)||1):1;const grouped=selections.reduce((items,id)=>{items[id]=(items[id]||0)+quantity;return items;},{});const nativeCartDrawer=document.querySelector('cart-drawer');const discount=selections.length===2?Number(this.dataset.twoDiscount||0):selections.length===3?Number(this.dataset.threeDiscount||0):0;const bundleLabel=this.dataset.bundleMode==='breech_shirt'&&selections.length===2?'Breech+shirt':`${selections.length}-item shirt bundle`;const body={items:Object.entries(grouped).map(([id,itemQuantity])=>({id:Number(id),quantity:itemQuantity,properties:discount?{'_AQ bundle':bundleLabel,'_AQ bundle discount':`${discount}%`}:{}}))};if(nativeCartDrawer?.getSectionsToRender){body.sections=nativeCartDrawer.getSectionsToRender().map((section)=>section.id);}this.button.disabled=true;this.error.hidden=true;try{const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add this selection.');let drawerHandled=false;if(nativeCartDrawer?.renderContents&&result.sections){nativeCartDrawer.renderContents(result);drawerHandled=true;}document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:result}}));if(!drawerHandled){const externalDrawer=document.getElementById('kaching-cart')||document.querySelector('kaching-cart-drawer');if(externalDrawer)externalDrawer.classList.add('active');else window.location.assign('/cart');}}catch(error){this.error.textContent=error.message;this.error.hidden=false;}finally{this.button.disabled=false;}};};const hydrateProduct=(product)=>{product.querySelectorAll('.aq-mini-faq').forEach(ensureFeatureAccordion);classifyProductOptions(product);hydrateFeatureLists(product);product.querySelectorAll('aq-bundle-selector').forEach(normalizeAqProduct);};const initProducts=()=>{const products=[...document.querySelectorAll('.aq-product')];if(!products.length)return;products.forEach((product)=>{hydrateProduct(product);let frame=0;const observer=new MutationObserver(()=>{window.cancelAnimationFrame(frame);frame=window.requestAnimationFrame(()=>hydrateProduct(product));});observer.observe(product,{childList:true,subtree:true});});customElements.whenDefined('aq-bundle-selector').then(()=>{patchAqSelector();products.forEach(hydrateProduct);});};if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>{startClsMeter();initProducts();},{once:true});}else{startClsMeter();initProducts();}})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aq-product-conversion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aq-bundle-selector')) {
    customElements.define('aq-bundle-selector', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-aq-variants]').textContent);
        this.optionNames = JSON.parse(this.querySelector('[data-aq-option-names]').textContent);
        this.optionSwatches = JSON.parse(this.querySelector('[data-aq-option-swatches]').textContent);
        this.bundleProducts = JSON.parse(this.querySelector('[data-aq-bundle-products]').textContent);
        this.breechProducts = JSON.parse(this.querySelector('[data-aq-breech-products]').textContent);
        this.shirtProducts = JSON.parse(this.querySelector('[data-aq-shirt-products]').textContent);
        this.bundleVariants = this.bundleProducts.flatMap(bundleProduct => bundleProduct.variants.map(variant => ({...variant, productTitle: bundleProduct.title, productImage: bundleProduct.image})));
        this.items = this.querySelector('[data-aq-items]');
        this.button = this.querySelector('[data-aq-add]');
        this.error = this.querySelector('[data-aq-error]');
        this.section = this.closest('.aq-product');
        this.optionsRoot = this.section.querySelector('[data-aq-product-options]');
        this.buildProductOptions();
        this.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change', () => this.changePlan(input)));
        if (this.dataset.purchaseMode !== 'kaching') this.button.addEventListener('click', () => this.add());
        this.quantityInput = this.querySelector('[data-aq-quantity]');
        this.querySelector('[data-aq-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1));
        this.querySelector('[data-aq-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1));
        this.quantityInput?.addEventListener('change', () => { this.quantityInput.value = Math.max(1, Number(this.quantityInput.value) || 1); this.updateTotal(); });
        this.section.querySelectorAll('.aq-gallery__thumb').forEach(thumb => thumb.addEventListener('click', () => this.changeImage(thumb)));
        this.section.querySelector('[data-aq-thumbs-prev]')?.addEventListener('click', () => this.scrollThumbnails(-1));
        this.section.querySelector('[data-aq-thumbs-next]')?.addEventListener('click', () => this.scrollThumbnails(1));
        this.sticky = this.section.querySelector('[data-aq-sticky]');
        this.stickyVariantSelect = this.section.querySelector('[data-aq-sticky-variant]');
        this.stickyVariantSelect?.addEventListener('change', () => {
          const variant = this.variants.find(item => String(item.id) === String(this.stickyVariantSelect.value));
          if (variant?.available) this.applyProductSelection(variant);
        });
        this.section.querySelector('[data-aq-sticky-add]')?.addEventListener('click', () => this.dataset.purchaseMode === 'kaching' ? this.button.click() : this.add());
        if (this.sticky) {
          this.stickyAnchor = this.dataset.purchaseMode === 'kaching' ? this.querySelector('[data-aq-kaching-form]') : this.button;
          this.updateStickyVisibility = () => {
            const rect = this.stickyAnchor?.getBoundingClientRect();
            const show = window.innerWidth <= 989 && Boolean(rect && rect.bottom < 0);
            this.sticky.classList.toggle('is-visible', show);
            this.sticky.setAttribute('aria-hidden', String(!show));
          };
          window.addEventListener('scroll', this.updateStickyVisibility, {passive:true});
          window.addEventListener('resize', this.updateStickyVisibility, {passive:true});
          requestAnimationFrame(this.updateStickyVisibility);
        }
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.closePickers();
        });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape') this.closePickers();
        });
        this.loadPairs();
        this.changePlan(this.querySelector('input[type="radio"]:checked'));
      }
      money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:window.Shopify?.currency?.active || 'CAD'}).format(cents / 100);
      }
      changeQuantity(change) {
        if (!this.quantityInput) return;
        this.quantityInput.value = Math.max(1, (Number(this.quantityInput.value) || 1) + change);
        this.updateTotal();
      }
      colourBackground(value, assignedSwatch) {
        const colourFor = name => {
          const key = String(name || '').trim().toLowerCase();
          if (key.includes('mauve')) return '#c8a2c8';
          if (key.includes('sage')) return '#9caf88';
          if (key.includes('slate')) return '#9bb4d3';
          if (key.includes('light blue') || key.includes('baby blue')) return '#add8e6';
          if (key.includes('navy')) return '#1f2a44';
          if (key.includes('light grey') || key.includes('light gray')) return '#cfcfcf';
          if (key.includes('grey') || key.includes('gray')) return '#8a8a8a';
          if (key.includes('beige')) return '#e8d7ad';
          if (key.includes('cream')) return '#f3ead3';
          if (key.includes('brown')) return '#a66035';
          if (key.includes('black')) return '#050505';
          if (key.includes('white')) return '#ffffff';
          if (key.includes('pink')) return '#f7a8c4';
          if (key.includes('green')) return '#3f7d4f';
          if (key.includes('blue')) return '#6f99c8';
          if (key.includes('red')) return '#c0392b';
          if (key.includes('purple')) return '#7d5ba6';
          return '#f1f1f1';
        };
        const parts = String(value || '').split('/').map(part => part.trim()).filter(part => part && !/logo/i.test(part));
        const colours = parts.map(colourFor);
        if (colours.length > 1) return `linear-gradient(135deg, ${colours[0]} 0 50%, ${colours[1]} 50% 100%)`;
        if (typeof assignedSwatch === 'string' && assignedSwatch) return assignedSwatch;
        return colours[0] || '#f1f1f1';
      }
      buildProductOptions() {
        if (!this.optionsRoot || !this.optionNames?.length || (this.optionNames.length === 1 && this.optionNames[0] === 'Title')) return;
        const initial = this.variants.find(variant => String(variant.id) === String(this.dataset.currentVariantId)) || this.variants.find(variant => variant.available) || this.variants[0];
        this.optionSelections = [...initial.options];
        this.optionsRoot.replaceChildren();
        this.optionNames.forEach((name, optionIndex) => {
          const group = document.createElement('fieldset');
          group.className = 'aq-option-group';
          group.dataset.optionIndex = optionIndex;
          const legend = document.createElement('legend');
          const selectedLabel = document.createElement('span');
          selectedLabel.dataset.aqOptionSelection = optionIndex;
          legend.append(document.createTextNode(`${name}: `), selectedLabel);
          const choices = document.createElement('div');
          choices.className = 'aq-option-group__choices';
          const values = [...new Set(this.variants.map(variant => variant.options[optionIndex]))];
          const isColour = /colou?r/i.test(name);
          values.forEach(value => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = `aq-option-pill${isColour ? ' aq-option-pill--colour' : ''}`;
            button.dataset.optionIndex = optionIndex;
            button.dataset.optionValue = value;
            button.setAttribute('aria-label', `${name}: ${value}`);
            if (isColour) {
              const assignedSwatch = this.optionSwatches?.[optionIndex]?.values?.find(item => item.value === value)?.color;
              const swatch = document.createElement('span');
              swatch.className = 'aq-option-pill__swatch';
              swatch.style.background = this.colourBackground(value, assignedSwatch);
              const copy = document.createElement('span');
              copy.textContent = value;
              button.append(swatch, copy);
            } else {
              button.textContent = value;
            }
            button.addEventListener('click', () => this.selectProductOption(optionIndex, value));
            choices.append(button);
          });
          group.append(legend, choices);
          this.optionsRoot.append(group);
        });
        this.hasProductPills = true;
        this.optionsRoot.hidden = false;
        this.applyProductSelection(initial);
      }
      selectProductOption(optionIndex, value) {
        const requested = [...this.optionSelections];
        requested[optionIndex] = value;
        let variant = this.variants.find(item => item.available && item.options.every((option, index) => option === requested[index]));
        if (!variant) variant = this.variants.find(item => item.available && item.options[optionIndex] === value);
        if (!variant) return;
        this.applyProductSelection(variant);
      }
      applyProductSelection(variant) {
        if (!variant) return;
        this.optionSelections = [...variant.options];
        this.dataset.currentVariantId = variant.id;
        const kachingVariant = this.querySelector('[data-aq-kaching-variant]');
        if (kachingVariant) kachingVariant.value = variant.id;
        this.optionNames.forEach((name, optionIndex) => {
          const selectedLabel = this.optionsRoot?.querySelector(`[data-aq-option-selection="${optionIndex}"]`);
          if (selectedLabel) selectedLabel.textContent = this.optionSelections[optionIndex];
          this.optionsRoot?.querySelectorAll(`[data-option-index="${optionIndex}"][data-option-value]`).forEach(button => {
            const value = button.dataset.optionValue;
            const isColour = /colou?r/i.test(name);
            const candidate = isColour
              ? this.variants.some(item => item.available && item.options[optionIndex] === value)
              : this.variants.some(item => item.available && item.options[optionIndex] === value && item.options.every((option, index) => index === optionIndex || option === this.optionSelections[index]));
            const selected = value === this.optionSelections[optionIndex];
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
            button.disabled = !candidate;
            button.classList.toggle('is-unavailable', !candidate);
          });
        });
        const price = this.section.querySelector('[data-aq-price]');
        if (price) price.textContent = this.money(variant.price);
        const imageUrl = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image?.src || variant.featured_image?.url;
        if (imageUrl) {
          const image = this.section.querySelector('.aq-gallery__main');
          if (image) { image.src = imageUrl; image.srcset = ''; }
        }
        if (this.stickyVariantSelect) {
          this.stickyVariantSelect.value = String(variant.id);
          const stickyOption = this.stickyVariantSelect.options[this.stickyVariantSelect.selectedIndex];
          const stickyImage = this.section.querySelector('[data-aq-sticky-image]');
          const stickyImageUrl = stickyOption?.dataset.image || imageUrl || this.dataset.currentProductImage;
          if (stickyImage && stickyImageUrl) { stickyImage.src = stickyImageUrl; stickyImage.srcset = ''; }
        }
        const stickyPrice = this.section.querySelector('[data-aq-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = this.money(variant.price);
        const singleSelect = this.items?.querySelector('select');
        const checkedPlan = this.querySelector('input[type="radio"]:checked');
        if (singleSelect && checkedPlan?.value === '1') {
          singleSelect.value = String(variant.id);
          singleSelect.dispatchEvent(new Event('change', {bubbles:true}));
        }
      }
      changePlan(input) {
        if (!input) return;
        this.querySelectorAll('.aq-plan').forEach(plan => plan.classList.toggle('is-selected', plan.contains(input)));
        const count = Number(input.value);
        const mixedBreechShirt = this.dataset.bundleMode === 'breech_shirt' && count === 2;
        this.classList.toggle('is-single-with-pills', count === 1 && this.hasProductPills);
        if (this.optionsRoot && this.hasProductPills) this.optionsRoot.hidden = count !== 1;
        const selected = this.items.querySelector('select')?.value || String(this.variants.find(variant => variant.available)?.id || this.variants[0].id);
        this.items.replaceChildren();
        for (let index = 0; index < count; index += 1) {
          const row = document.createElement('div');
          row.className = 'aq-bundle-item';
          const label = document.createElement('label');
          label.textContent = mixedBreechShirt ? (index === 0 ? '1. Choose a breech' : '2. Choose a shirt') : `${count === 1 ? 'Selection' : 'Item'} ${index + 1}`;
          const select = document.createElement('select');
          select.setAttribute('aria-label', label.textContent);
          if (count === 1) {
            this.variants.forEach(variant => this.appendVariantOption(select, variant, this.dataset.currentProductTitle, this.dataset.currentProductImage, selected));
          } else if (mixedBreechShirt) {
            const products = index === 0 ? this.breechProducts : this.shirtProducts;
            products.forEach(bundleProduct => {
              const group = document.createElement('optgroup');
              group.label = bundleProduct.title;
              bundleProduct.variants.forEach(variant => this.appendVariantOption(group, variant, bundleProduct.title, bundleProduct.image, selected));
              select.append(group);
            });
          } else {
            this.bundleProducts.forEach(bundleProduct => {
              const group = document.createElement('optgroup');
              group.label = bundleProduct.title;
              bundleProduct.variants.forEach(variant => this.appendVariantOption(group, variant, bundleProduct.title, bundleProduct.image, selected));
              select.append(group);
            });
          }
          select.hidden = true;
          select.addEventListener('change', () => {
            this.updatePicker(row, select);
            this.updateTotal();
          });
          row.append(label, select);
          this.buildPicker(row, select);
          this.items.append(row);
        }
        this.updateTotal();
        if (count === 1 && this.hasProductPills) {
          const selectedVariant = this.variants.find(variant => String(variant.id) === String(this.dataset.currentVariantId));
          this.applyProductSelection(selectedVariant);
        }
      }
      appendVariantOption(parent, variant, productTitle, productImage, selected) {
        const option = document.createElement('option');
        const variantImage = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image?.src || variant.featured_image?.url;
        option.value = variant.id;
        option.dataset.price = variant.price;
        option.dataset.image = variantImage || productImage || '';
        option.textContent = `${productTitle} — ${variant.title} — ${this.money(variant.price)}${variant.available ? '' : ' — Sold out'}`;
        option.disabled = !variant.available;
        option.selected = String(variant.id) === selected;
        parent.append(option);
      }
      buildPicker(row, select) {
        const picker = document.createElement('div');
        picker.className = 'aq-visual-picker';
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'aq-visual-picker__trigger';
        trigger.setAttribute('aria-expanded', 'false');
        const menu = document.createElement('div');
        menu.className = 'aq-visual-picker__menu';
        menu.hidden = true;
        [...select.options].forEach(option => {
          if (option.disabled) return;
          const choice = document.createElement('button');
          choice.type = 'button';
          choice.className = 'aq-visual-picker__choice';
          const image = document.createElement('img');
          image.src = option.dataset.image;
          image.alt = '';
          image.loading = 'lazy';
          const copy = document.createElement('span');
          copy.textContent = option.textContent;
          choice.append(image, copy);
          choice.addEventListener('click', () => {
            select.value = option.value;
            select.dispatchEvent(new Event('change', {bubbles:true}));
            this.closePickers();
          });
          menu.append(choice);
        });
        trigger.addEventListener('click', event => {
          event.stopPropagation();
          const willOpen = menu.hidden;
          this.closePickers();
          menu.hidden = !willOpen;
          trigger.setAttribute('aria-expanded', String(willOpen));
        });
        picker.append(trigger, menu);
        row.append(picker);
        this.updatePicker(row, select);
      }
      updatePicker(row, select) {
        const option = select.options[select.selectedIndex];
        const trigger = row.querySelector('.aq-visual-picker__trigger');
        if (!option || !trigger) return;
        trigger.replaceChildren();
        const image = document.createElement('img');
        image.src = option.dataset.image;
        image.alt = '';
        const copy = document.createElement('span');
        copy.textContent = option.textContent.replace(' — Sold out', '');
        const arrow = document.createElement('b');
        arrow.textContent = '⌄';
        trigger.append(image, copy, arrow);
      }
      closePickers() {
        this.querySelectorAll('.aq-visual-picker__menu').forEach(menu => { menu.hidden = true; });
        this.querySelectorAll('.aq-visual-picker__trigger').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      }
      async loadPairs() {
        const section = this.section.querySelector('[data-aq-pairs]');
        const list = section?.querySelector('[data-aq-pairs-list]');
        if (!section || !list) return;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}recommendations/products.json?product_id=${section.dataset.productId}&limit=3&intent=complementary`);
          if (!response.ok) return;
          const result = await response.json();
          const products = (result.products || []).slice(0, 3);
          if (!products.length) return;
          products.forEach(pairProduct => {
            const card = document.createElement('article');
            card.className = 'aq-pair-card';
            const media = document.createElement('a');
            media.className = 'aq-pair-card__media';
            media.href = pairProduct.url;
            const image = document.createElement('img');
            const featuredImage = typeof pairProduct.featured_image === 'string' ? pairProduct.featured_image : pairProduct.featured_image?.src;
            image.src = featuredImage || pairProduct.images?.[0] || '';
            image.alt = pairProduct.title;
            image.loading = 'lazy';
            media.append(image);
            const copy = document.createElement('div');
            copy.className = 'aq-pair-card__copy';
            const title = document.createElement('a');
            title.href = pairProduct.url;
            title.textContent = pairProduct.title;
            const price = document.createElement('strong');
            price.textContent = pairProduct.price_varies ? `From ${this.money(pairProduct.price)}` : this.money(pairProduct.price);
            copy.append(title, price);
            const action = document.createElement('a');
            action.className = 'aq-pair-card__action';
            action.href = pairProduct.url;
            action.textContent = 'Choose options';
            card.append(media, copy, action);
            list.append(card);
          });
          section.hidden = false;
        } catch (error) {
          console.warn('Complementary products could not be loaded.', error);
        }
      }
      updateTotal() {
        const selects = [...this.items.querySelectorAll('select')];
        if (this.dataset.purchaseMode === 'kaching') return;
        if (this.dataset.purchaseMode === 'quantity') {
          const quantity = Math.max(1, Number(this.quantityInput?.value) || 1);
          const unitPrice = Number(selects[0]?.options[selects[0].selectedIndex]?.dataset.price || 0);
          const total = unitPrice * quantity;
          this.querySelector('[data-aq-button-text]').textContent = `Add to cart — ${this.money(total)}`;
          this.section.querySelector('[data-aq-sticky-price]').textContent = this.money(total);
          const stickyOption = this.section.querySelector('[data-aq-sticky-option]');
          if (stickyOption) stickyOption.textContent = `${quantity} × ${selects[0]?.options[selects[0].selectedIndex]?.text.split(' — ')[0] || this.dataset.currentProductTitle}`;
          return;
        }
        const subtotal = selects.reduce((sum, select) => sum + Number(select.options[select.selectedIndex]?.dataset.price || 0), 0);
        const discount = selects.length === 2 ? Number(this.dataset.twoDiscount || 0) : selects.length === 3 ? Number(this.dataset.threeDiscount || 0) : 0;
        const total = Math.round(subtotal * (100 - discount) / 100);
        this.querySelector('[data-aq-button-text]').textContent = `Add to cart — ${this.money(total)}`;
        const planPrice = this.querySelector(`[data-plan-price="${selects.length}"]`);
        if (planPrice) planPrice.textContent = selects.length === 1 ? this.money(total) : `${this.money(total)} · Save ${discount}%`;
        this.section.querySelector('[data-aq-sticky-price]').textContent = this.money(total);
        const selectedOptions = selects.map(select => select.options[select.selectedIndex]?.text.split(' — ')[0]);
        const stickyOption = this.section.querySelector('[data-aq-sticky-option]');
        if (stickyOption) stickyOption.textContent = selectedOptions.length === 1 ? selectedOptions[0] : `${selectedOptions.length}-item bundle`;
      }
      changeImage(thumb) {
        const image = this.section.querySelector('.aq-gallery__main');
        image.src = thumb.dataset.imageSrc;
        image.srcset = '';
        image.alt = thumb.dataset.imageAlt;
        this.section.querySelectorAll('.aq-gallery__thumb').forEach(item => item.classList.toggle('is-active', item === thumb));
      }
      scrollThumbnails(direction) {
        const track = this.section.querySelector('.aq-gallery__thumbs');
        track.scrollBy({left: direction * Math.max(track.clientWidth * 0.72, 220), behavior: 'smooth'});
      }
      async add() {
        const selections = [...this.items.querySelectorAll('select')].map(select => select.value);
        const quantity = this.dataset.purchaseMode === 'quantity' ? Math.max(1, Number(this.quantityInput?.value) || 1) : 1;
        const grouped = selections.reduce((items, id) => { items[id] = (items[id] || 0) + quantity; return items; }, {});
        const cartDrawer = document.querySelector('cart-drawer');
        const discount = selections.length === 2 ? Number(this.dataset.twoDiscount || 0) : selections.length === 3 ? Number(this.dataset.threeDiscount || 0) : 0;
        const bundleLabel = this.dataset.bundleMode === 'breech_shirt' && selections.length === 2 ? 'Breech + shirt' : `${selections.length}-item shirt bundle`;
        const body = {items:Object.entries(grouped).map(([id, quantity]) => ({
          id:Number(id),
          quantity,
          properties: discount ? {'_AQ bundle':bundleLabel,'_AQ bundle discount':`${discount}%`} : {}
        }))};
        if (cartDrawer?.getSectionsToRender) body.sections = cartDrawer.getSectionsToRender().map(section => section.id);
        this.button.disabled = true;
        this.error.hidden = true;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add this selection.');
          if (cartDrawer?.renderContents && result.sections) cartDrawer.renderContents(result);
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:result}}));
          document.querySelector('#kaching-cart')?.classList.add('active');
          document.querySelector('kaching-cart-drawer')?.classList.add('active');
          if (!cartDrawer && !document.querySelector('#kaching-cart, kaching-cart-drawer')) window.location.assign('/cart');
        } catch (error) {
          this.error.textContent = error.message;
          this.error.hidden = false;
        } finally {
          this.button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
